// Employee-portal paths → My view paths. Used by the dashboard action items
// (GET /dashboard/me still returns the old paths) and by the redirects in
// routes/AppRoutes.js, so old links and bookmarks keep working.
// Longest prefix first; query strings and trailing ids are kept.
export const LEGACY_PREFIXES = [
  ["/my-dtr/history", "/me/dtr"],
  ["/my-dtr", "/me/dtr"],
  ["/my-overtime", "/me/overtime"],
  ["/my-leaves", "/me/leaves"],
  ["/leave-request", "/me/leaves"],
  ["/my-assets", "/me/assets"],
  ["/my-evaluations", "/me/evaluations"],
  ["/evaluations-to-rate", "/me/evaluations-to-rate"],
  ["/my-learning", "/me/learning"],
  ["/my-profile", "/me/profile"],
];

/** "/my-dtr?week=2026-10-19" → "/me/dtr?week=2026-10-19"; other links unchanged. */
export const toMyViewPath = (link) => {
  if (typeof link !== "string") return link;
  for (const [from, to] of LEGACY_PREFIXES) {
    if (
      link === from ||
      link.startsWith(`${from}/`) ||
      link.startsWith(`${from}?`)
    )
      return to + link.slice(from.length);
  }
  return link;
};
